<template>
  <div class="DetailsSlide">
    <SlideHeading v-bind="{ content }" />
    <div class="inputFields">
      <component v-for="{ fieldName, fieldTitle } in content.fields"
        :key="fieldName"
        :is="fieldConfig[fieldName].component"
        :name="fieldName"
        :title="fieldTitle"
        :value="fieldValues[fieldName]"
        :error="fieldErrors[fieldName]"
        :optional="!fieldConfig[fieldName].required"
        :disabled="!isCurrentSlide"
        @change="$emit('updateField', fieldName, $event.target.value, 'change')"
        @input="$emit('updateField', fieldName, $event.target.value, 'input')"
      />
    </div>
    <a v-if="content.privacyLink && content.privacyLink.text"
      :href="content.privacyLink.url"
      class="privacyLink"
    >
      {{ content.privacyLink.text }}
    </a>
  </div>
</template>

<script>
import SlideHeading from './elems/SlideHeading.vue'
import TextInput from '~/vue-components/wizard/slides/elems/TextInput.vue'
import TextAreaInput from '~/vue-components/wizard/slides/elems/TextAreaInput.vue'

export default {
  components: {
    SlideHeading,
    TextInput,
    TextAreaInput,
  },
  props: {
    content: Object,
    isCurrentSlide: Boolean,
    selectedOptions: Object,
    fieldConfig: Object,
    fieldValues: Object,
    fieldErrors: Object,
  },
}
</script>

<style scoped>
.DetailsSlide {
  --field-title-color: var(--text-color-white);
  --field-annotation-size: var(--font-size-2);
  --field-annotation-color: var(--text-color-white);
  --field-error-color: #FF7474;
}
.inputFields {
  margin-top: var(--spacing-4);
  max-width: var(--narrow-child-width);
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-4);
}
.privacyLink {
  margin-top: var(--spacing-3);
  display: inline-block;
  font-weight: 400;
  font-size: var(--font-size-1);
  color: var(--text-color-white);
  text-decoration: underline;
}
.privacyLink:hover {
  opacity: 0.75;
}
</style>
